module.exports = __webpack_public_path__ + "static/03-e3872eab0d98ed0e2101d03d675a6062.jpg";